import { defineComponent as _defineComponent } from 'vue'
import { computed as _computed } from 'vue';

import formatDate from '@/utils/filters/formatDate';
import fromNow from '@/utils/filters/fromNow';
import capitalizeFirst from '@/utils/filters/capitalizeFirst';

interface DateTooltipProps {
  value?: string | number;
  capitalize?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Date-Tooltip',
  props: {
  value: null,
  capitalize: { type: Boolean, default: false }
},
  setup(__props) {

const props = __props;


const formattedDate = _computed(() => (props.value ? formatDate(props.value) : ''));

const fromNowDate = _computed(() => (props.capitalize ? capitalizeFirst(fromNow(props.value)) : fromNow(props.value)));

return { __sfc: true,props, formattedDate, fromNowDate, _computed, formatDate, fromNow, capitalizeFirst }
}

})